import { cloneDeep } from "lodash";
import { initialState } from "../initialState";
import { bannerActions as actions } from "../actions";
import { createReducer, methodSwitcher } from "./utilities";

const { banner } = initialState;

const clearCurrent = (state) => ({ ...state, current: {} });

const setBannerList = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.list = data;
  return newState;
};

const setCurrentBanner = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.current = data;
  return newState;
};

const actionBanner = (state, { data, id, method }) => {
  const newState = cloneDeep(state);
  methodSwitcher(newState, data, id, method);
  return newState;
};

export const bannerReducer = createReducer(banner, {
  [actions.LIST]: setBannerList,
  [actions.CLEAR_CURRENT]: clearCurrent,
  [actions.CURRENT]: setCurrentBanner,
  [actions.CUD]: actionBanner,
});
